module.exports = "/images/lambee.png?e7dbe00cdeabda3ee72c277532506ec8";